module.exports = __webpack_public_path__ + "img/ics_o_kirim_tagihan.5e1bb96d.svg";